import React, { FC } from 'react';
import styled from 'styled-components';

import { QiwiMethod } from '~/api/finance/financeApiTypes';
import { choosePaySelector } from '~/feature/finance/BuyingSteps/ChoosePay/choosePay.selector';
import { useAppSelector } from '~/store';

import { DefaultMethodPaymentParams, MethodPaymentTemplate } from './MethodPaymentTemplate';

interface QiwiMethodPaymentProps extends DefaultMethodPaymentParams {
  method: QiwiMethod;
}

export const QiwiMethodPayment: FC<QiwiMethodPaymentProps> = ({
  method, onCheck, ...props
}) => {
  const { activeMethod } = useAppSelector(choosePaySelector);

  return (
    <MethodPaymentTemplate
      Logo={(
        <SCIcon
          src="/icon/components/QiwiMethodPayment/qiwiIcon.svg"
        />
      )}
      Text={(
        <>
          Qiwi кошелек
        </>
      )}
      onCheck={() => {
        if (onCheck) {
          onCheck(method);
        }
      }}
      {...props}
    />
  );
};

const SCIcon = styled.img`
  width: 48px;
  height: 48px;
`;
